// What the round's recap (components/game/RoundSummaryDialog.jsx) reads from a row of `round_summary`
// (end_round in backend/game/actions.py).

// The game's winners, best first: two at a table of 4, else one (a server not updated yet sends its one winner).
export function gameWinners(game) {
  if (game?.game_winners?.length) return game.game_winners;
  return game?.game_winner_id ? [game.game_winner_id] : [];
}

export const MEDALS = ["🥇", "🥈"];

// The game's winners in their order; then the lowest score first, as the game counts it; the players out before
// this round come last.
export function standings(rows = [], winners = []) {
  const place = (r) => {
    const i = winners.indexOf(r.user_id);
    return i === -1 ? winners.length : i;
  };
  return rows.slice().sort((a, b) => {
    if (place(a) !== place(b)) return place(a) - place(b);
    if (!!a.previously_eliminated !== !!b.previously_eliminated) return a.previously_eliminated ? 1 : -1;
    return a.score_after - b.score_after;
  });
}

// A row's points. The cards left add up in one number (they are on screen, a line per card told nothing more);
// everything else is a line of its own, a kind repeated (several Jokers) once with its count.
export function penaltyLines(row) {
  let cards = 0;
  const lines = [];
  for (const b of row?.penalty_breakdown || []) {
    if (b.type === "card") {
      cards += b.points;
      continue;
    }
    const same = lines.find((l) => l.type === b.type && l.label === b.label);
    if (same) {
      same.count += 1;
      same.points += b.points;
    } else {
      lines.push({ type: b.type, label: b.label, count: 1, points: b.points });
    }
  }
  return { cards, lines };
}

// Where a score stands on the way to elimination, in fractions of the bar: what it held before the round, what
// the round added, and how close it now is.
export function scoreBar(before, after, limit) {
  const part = (n) => (limit > 0 ? Math.max(0, Math.min(1, n / limit)) : 0);
  const end = part(after);
  const start = Math.min(part(before), end);
  return { before: start, added: end - start, level: end >= 0.75 ? "danger" : end >= 0.5 ? "warning" : "safe" };
}
